import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import styles from './NonEval.module.css';
import { DBIntField, AddButton, DBCheckBox } from '_components';
import { PatientCareCenterNoteSubjectiveNonEvalEntry } from './NonEvalEntry';
import { getDateMDYYYY } from '_helpers';
import { PatientCareCenterNoteSubjectiveWorkComp } from './WorkComp';


class PatientCareCenterNoteSubjectiveNonEval extends React.Component {

    handleAdd() {
        this.props.addChildRow(this.props.noteId, 'PTSUBJECTIVE', 'SU', 'SUNTNO', this.props.pk);
    }

    getSentence(prevEntry) {
        let retval = '';
        retval += prevEntry.MSNAME.endsWith('...') ? prevEntry.MSNAME.slice(0, -3) + ' ' : prevEntry.MSNAME === 'Other' ? '' : prevEntry.MSNAME + ' ';
        retval += prevEntry.SUDETAILS
        return retval;
    }

    render() {
        let firstEntry = this.props.entries.length > 0 ? this.props.entries[0] : -1;

        return (
            <div>
                <div className={styles.row}>
                    <label className={this.props.isPainRequired ? styles.col1_required : styles.col1}>Patient Reports Pain</label>
                    <DBIntField
                        noteId={this.props.noteId}
                        entity='PTNOTE'
                        entityKeyColumn='NTNO'
                        entityKeyValue={this.props.pk}
                        field='NTSUBPAIN'
                        min={0}
                        max={10}
                        className={styles.pain_input}
                    />
                    <label>&nbsp;/ 10</label>
                    {this.props.prevPain && this.props.prevPainDate &&
                        <label className={styles.prev_pain}>{this.props.prevPainDate + ' - ' + this.props.prevPain}</label>
                    }

                </div>

                <div className={styles.row}>
                    <label className={this.props.noteType !== 3 && this.props.noteType !== 4 ? styles.col1_required : styles.col1}>Subjective</label>
                </div>


                {Object.keys(this.props.entries)
                    .map(id => {
                        const entry = this.props.entries[id];
                        return (
                            <PatientCareCenterNoteSubjectiveNonEvalEntry key={entry} id={entry} firstEntry={entry === firstEntry} />
                        )
                    })
                }



                {this.props.prevEntries && this.props.prevEntries.length > 0 &&
                    <div className={styles.row}>
                        <span className={styles.col1}>
                            {getDateMDYYYY(this.props.prevEntries[0].DOS) + ' Subjective'}
                        </span>
                        <span className={styles.col2}>
                            {Object.keys(this.props.prevEntries)
                                .map(id => {
                                    const prevEntry = this.props.prevEntries[id];
                                    return (
                                        <label key={prevEntry.SUNO} className={styles.prev_entry}>
                                            {this.getSentence(prevEntry)}
                                        </label>
                                    )
                                })
                            }
                        </span>
                    </div>
                }

                {(!this.props.prevEntries || this.props.prevEntries.length === 0) && this.props.evalSubjective &&
                    <div className={styles.row}>
                        <span className={styles.col1}>
                            {getDateMDYYYY(this.props.evalSubjective.DOS) + ' Subjective'}
                        </span>
                        <span className={styles.col2}>
                            <label className={styles.prev_entry}>
                                {this.props.evalSubjective.EVSUBHISDETAILS}
                            </label>

                        </span>
                    </div>
                }

                <div className={styles.checkbox_row}>
                    <DBCheckBox noteId={this.props.noteId} entity='PTNOTE' entityKeyColumn='NTNO' entityKeyValue={this.props.ntno} field='NTTELECONSENT' label='Patient has consented to be seen via telehealth on doxy.me' />
                </div>

                <PatientCareCenterNoteSubjectiveWorkComp />

            </div>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        addChildRow: bindActionCreators(noteActions.addChildRow, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);

    let entries = Object.keys(state.entities.notes.PTSUBJECTIVE)
        .filter(key => state.entities.notes.PTSUBJECTIVE[key].SUNTNO === pk)
        .sort((a, b) => state.entities.notes.PTSUBJECTIVE[a].SUNO - state.entities.notes.PTSUBJECTIVE[b].SUNO)
        .map(key => state.entities.notes.PTSUBJECTIVE[key].SUNO);

    let prevEntries = Object.keys(state.entities.notes.PTSUBJECTIVEPREV)
        .filter(key => state.entities.notes.PTSUBJECTIVEPREV[key].NTNO === pk)
        .sort((a, b) => state.entities.notes.PTSUBJECTIVEPREV[a].SUNO - state.entities.notes.PTSUBJECTIVEPREV[b].SUNO)
        .map(key => state.entities.notes.PTSUBJECTIVEPREV[key]);
    let evalSubjective = state.entities.notes.PTEVALSUBJECTIVE[noteId];

    let prevPain = state.entities.notes.PTPAINPREV[noteId].PREVPAIN;
    let prevPainDate = state.entities.notes.PTPAINPREV[noteId].DOS ? getDateMDYYYY(state.entities.notes.PTPAINPREV[noteId].DOS) : undefined;

    let ntno = parseInt(noteId.split("_")[1]);
    let epno = state.entities.notes.PTNOTE[pk].NTEPNO;
    let isWc = state.entities.admissions[epno].isWc;
    let admitRequiresPain = state.entities.admissions[epno].isPainRequired;

    let isPainRequired = (isWc || admitRequiresPain);

    return {
        noteId,
        noteType,
        pk,
        entries,
        prevEntries,
        prevPain,
        prevPainDate,
        isPainRequired,
        evalSubjective,
        ntno
    };
}

const connectedPatientCareCenterNoteSubjectiveNonEval = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteSubjectiveNonEval);
export { connectedPatientCareCenterNoteSubjectiveNonEval as PatientCareCenterNoteSubjectiveNonEval };

